import { LogoffPage } from '@repo/auth/react';
import { Loader } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { lazy, Suspense, type FC } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { dashboardServiceAgent } from 'src/api/dashboard-service-agent';
import { wellDirectoryServiceAgent } from 'src/api/well-directory-service-agent';
import { useService } from 'src/packages/di';
import { DashboardPage } from 'src/pages/dashboard/DashboardPage';
import { SettingsPage } from 'src/pages/settings/SettingsPage';
import { TabPage } from 'src/pages/tab/TabPage';

import { PagesContainer } from '../PagesContainer';
import { useStore } from '../root-store';

const ReportApp = lazy(() => import('@repo/go-report-2').then((module) => ({ default: module.ReportApp })));

export const Router: FC = observer(function Router() {
  const theme = useService('theme');
  const language = useService('language');
  const directoriesService = useService('directories');
  const wellsData = useService('wellsData');
  const authService = useService('authService');
  const userPreferences = useService('userPreference');
  const wellStatusService = useService('wellStatusService');

  const userData = {
    name: authService.userInfo.name || authService.userInfo.preferred_username,
    sub: authService.userInfo.sub,
  };
  const { sidebar } = useStore();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/logoff" element={<LogoffPage />} />
        <Route path="/" element={<PagesContainer />}>
          <Route index element={<DashboardPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/tab/:id" element={<TabPage />} />
          <Route
            path={'/report/*'}
            element={
              // TODO: Сообразить нормальный сервис управления доступами к приложениям
              <Suspense fallback={<Loader />}>
                <ReportApp
                  pagesGroupsAvailable={['depthDay', 'gti', 'wellDetails']}
                  onOpenSidebar={sidebar.open}
                  language={language}
                  theme={theme}
                  directoriesService={directoriesService}
                  wdAgent={dashboardServiceAgent}
                  wellDirectoryServiceAgent={wellDirectoryServiceAgent}
                  userData={userData}
                  dashboardUserPreferences={userPreferences}
                  wellStatusService={wellStatusService}
                  wellsData={wellsData}
                />
              </Suspense>
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
});

export default Router;
